import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full',
    }, {
        path: '',
        component: AdminLayoutComponent,
        children: [

            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },

            {
                path: 'home',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },

            {
                path: 'elections',
                loadChildren: './vote/vote.module#VoteModule'
            },

            {
                path: 'student',
                loadChildren: './student/student.module#StudentModule'
            },
            {
                path: 'notes',
                loadChildren: './notas/notas.module#NotasModule'
            },
            {
                path: 'page-not-found',
                component: PageNotFoundComponent,
            }

            // , {
            //     path: 'third',
            //     loadChildren: './third/third.module#ThirdModule'
            // }, {
            //     path: 'egress',
            //     loadChildren: './egress/egress.module#EgressModule'
            // }, {
            //     path: 'bills',
            //     loadChildren: './bills/bills.module#BillsModule'
            // }

        ]
    }, {

        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: './pages/pages.module#PagesModule'
        },]

    }
];